/* ========================================================================== *\
    PUBLIC API
\* ========================================================================== */
export class Action {
    /* ======================================================================= *\
        CONSTRUCTOR
    \* ====================================================================== */
    constructor(detail, cancelable = false) {
        this._defaultPrevented = false;
        this._cancelable = cancelable;
        this._detail = detail !== null && detail !== void 0 ? detail : undefined;
    }
    /* ---------------------------------- *\
        cancellable
    \* ---------------------------------- */
    /**
     * Indicates whether or not the issue can be cancelled.
     *
     * @readonly
     * @memberof Issue
     */
    get cancelable() {
        return this._cancelable;
    }
    /* ---------------------------------- *\
        defaultPrevented
    \* ---------------------------------- */
    /**
     * Indicates whether or not the preventDefault method has been called on a
     * cancellable issue.
     *
     * @readonly
     * @memberof Issue
     */
    get defaultPrevented() { return this._defaultPrevented; }
    /* ---------------------------------- *\
        detail
    \* ---------------------------------- */
    /**
     * The payload of the issue as provided during the creation of the issue.
     *
     * @readonly
     * @memberof Issue
     */
    get detail() {
        return this._detail;
    }
    /* ====================================================================== *\
        PUBLIC METHODS
    \* ====================================================================== */
    /**
     * Informs the publisher of the issue that whatever action it was about to
     * perform should in fact not be performed.
     * Calling this method on an issue where cancelable is not true has
     * no effect.
     *
     * @memberof Issue
     */
    preventDefault() {
        this._defaultPrevented = this.cancelable;
    }
}
